import React, { Component } from 'react';
import { Col, Row, Panel, Alert, Button, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';

import {
  addDegree,
  removeDegree,
  addLicense,
  removeLicense,
  addCertificate,
  removeCertificate,
  updateProfessionalInfo,
  saveProfessionalInfo
} from '../actions';
import Degree from './Degree';
import License from './License';
import Certificate from './Certificate';
import WorkExperience from './WorkExperience';
import OtherWorkExperience from './OtherWorkExperience';
import FormSectionStatus from './FormSectionStatus';
import ProfessionalValidation from "../validation/professionalValidation";

class ProfessionalInfo extends Component {
  constructor(props){
    super(props);
    this.saveAndContinue = this.saveAndContinue.bind(this);
    this.handleAddDegree = this.handleAddDegree.bind(this);
    this.handleRemoveDegree = this.handleRemoveDegree.bind(this);
    this.handleAddLicense = this.handleAddLicense.bind(this);
    this.handleRemoveLicense = this.handleRemoveLicense.bind(this);
    this.handleAddCertificate = this.handleAddCertificate.bind(this);
    this.handleRemoveCertificate = this.handleRemoveCertificate.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e){
    const {dispatch} = this.props;
    let updates = {};
    updates[e.target.id] = e.target.value;
    dispatch(updateProfessionalInfo(updates));
  }

  handleAddDegree(e){
    e.preventDefault();
    const {dispatch} = this.props;
    dispatch(addDegree());
  }

  handleRemoveDegree(degreeId){
    const {dispatch} = this.props;
    dispatch(removeDegree(degreeId));
  }

  handleAddLicense(e){
    e.preventDefault();
    const {dispatch} = this.props;
    dispatch(addLicense());
  }

  handleRemoveLicense(licenseId){
    const {dispatch} = this.props;
    dispatch(removeLicense(licenseId));
  }

  handleAddCertificate(e){
    e.preventDefault();
    const {dispatch} = this.props;
    dispatch(addCertificate());
  }

  handleRemoveCertificate(certificateId){
    const {dispatch} = this.props;
    dispatch(removeCertificate(certificateId));
  }

  saveAndContinue(e){
    e.preventDefault();
    if(ProfessionalInfo.getValidationState() === 'success') {
      console.log('Update Database');
      this.props.dispatch(saveProfessionalInfo(this.props.professionalInfo));
      //this.props.nextStep();
    } else {
      console.log('Not Saved');
    }
  }

  static getValidationState(){
    return 'success';
  }

  render() {
    const { professionalInfo, colleges, nursingSynthesisStatus, upgradeOption, applicationEndDate } = this.props;
    const space = ' ';
    const validationStatus = new ProfessionalValidation(colleges).getValidationStatus(professionalInfo);

    const renderDegrees = () => {
      if(professionalInfo.degrees.length === 0) {
        return (
          <Alert bsStyle="warning">
            No degrees added.
          </Alert>
        )
      }

      return professionalInfo.degrees.map((degree) => {
        return (
          <Degree key={degree.id} {...degree} colleges={colleges} dispatch={this.props.dispatch} onRemoveDegree={this.handleRemoveDegree}/>
        );
      });
    };

    const renderLicenses = () => {
      if(professionalInfo.licenses.length === 0) {
        return (
          <Alert bsStyle="warning">
            <p>No licenses added</p>
            <p>
              Please add any unexpired licenses you have. You may add expired licenses if you
              have over 1,000 hours of work experience while holding an valid license.
            </p>
          </Alert>
        )
      }

      return professionalInfo.licenses.map((license) => {
        return (
          <License
            key={license.id}
            {...license}
            applicationEndDate={applicationEndDate}
            dispatch={this.props.dispatch}
            onRemoveLicense={this.handleRemoveLicense}
            nursingSynthesisStatus={nursingSynthesisStatus}
            upgradeOption={upgradeOption}/>
        );
      });
    };

    const renderCertificates = () => {
      if(professionalInfo.certificates.length === 0) {
        return (
          <Alert bsStyle="warning">
            <p>No certificates added</p>
            <p>
              Please add any unexpired certificates you have. You may add expired certificates if you
              have over 1,000 hours of work experience while holding an valid certificate.
            </p>
          </Alert>
        )
      }

      return professionalInfo.certificates.map((certificate) => {
        return (
          <Certificate
            key={certificate.id}
            {...certificate}
            applicationEndDate={applicationEndDate}
            dispatch={this.props.dispatch}
            onRemoveCertificate={this.handleRemoveCertificate}/>
        );
      });
    };

    const renderCertificateWorkExperience = () => {
      // Combined license and certificate work experience
      return professionalInfo.certificates.length > 0 ?
        <WorkExperience type='certificate' professionalInfo={professionalInfo} dispatch={this.props.dispatch} />
        :
        null;
    };

    const renderLicenseWorkExperience = () => {
      return professionalInfo.licenses.length > 0 ?
        <WorkExperience type='license' professionalInfo={professionalInfo} dispatch={this.props.dispatch} />
        :
        null;
    };

    return (
      <div>
        <h2>Professional Information</h2>
        <Panel>
          <h3>Criteria 1</h3>
          <p>In this section you'll add information about any degrees, certificates, licenses, or work experience in health sciences.</p>
          <hr/>
          <h4>Criterion 1A - Academic Degrees <small>Maximum Points: 5</small></h4>
          <p>Points will only be awarded for one degree. If you do not have an exact date, use the first of the month.</p>
          {renderDegrees()}
          <Row style={{marginBottom: '15px'}}>
            <Col xs={12}>
              <Button onClick={this.handleAddDegree}>
                <Glyphicon glyph="plus"/>
                {space} Add Degree
              </Button>
            </Col>
          </Row>
          <hr/>
          <h4>Criterion 1B - Licensed Health Care and Work Experience <small>Maximum Points: 10</small></h4>
          <p>Points will only be awarded for one current license.</p>
          {renderLicenses()}
          <Row style={{marginBottom: '15px'}}>
            <Col xs={12}>
              <Button onClick={this.handleAddLicense}>
                <Glyphicon glyph="plus"/>
                {space} Add License
              </Button>
            </Col>
          </Row>
          {renderLicenseWorkExperience()}
          <h4>Criterion 1C - Certified Health Care and Work Experience <small>Maximum Points: 5</small></h4>
          <p>Points will only be awarded for one current certificate.</p>
          {renderCertificates()}
          <Row style={{marginBottom: '15px'}}>
            <Col xs={12}>
              <Button onClick={this.handleAddCertificate}>
                <Glyphicon glyph="plus"/>
                {space} Add Certificate
              </Button>
            </Col>
          </Row>
          {renderCertificateWorkExperience()}
          <hr/>
          <h4>Criterion 1D - Health Care Work Experience Not Covered Under Criterion 1B or 1C <small>Maximum Points: 2</small></h4>
          <p>If you currently have a license or certificate that was not covered under Criterion 1B or 1C but have either of the following experiences, you may earn points here.</p>
          <p><strong>PLEASE NOTE: Direct patient care is defined as experience providing and assisting human clients with hands-on healthcare needs; not including clerical and administrative type of work</strong></p>
          <OtherWorkExperience professionalInfo={professionalInfo} dispatch={this.props.dispatch} />
        </Panel>
        <FormSectionStatus {...validationStatus.section}/>
      </div>
    );
  };
}

export default connect(
  (state) => {
    const { professionalInfo, educationInfo, appInfo, application } = state;
    const { applicationSet, applicationPeriods } = appInfo;
    const { upgradeOption } = application;
    const currentPeriod = applicationSet ? applicationPeriods.find(appPeriod => appPeriod.periodId === appInfo.application.periodId) : {};
    const { applicationEndDate } = currentPeriod;
    const { colleges } = educationInfo;
    let nursingSynthesisStatus = false;
    for(let college of colleges) {
      for(let course of college.courses) {
        if(course.requirement === 'nursingSynthesis') {
          nursingSynthesisStatus = true;
        }
      }
    }
    return {
      professionalInfo,
      colleges,
      applicationEndDate,
      nursingSynthesisStatus,
      upgradeOption
    };
  }
)(ProfessionalInfo);